export * from './duplicata-pagar-browse.component';
export * from './duplicata-pagar-edit.component';